const Iframe = () => {
	const frameSrc = localStorage.getItem('frameSrc');

	return (
		<iframe
			src={frameSrc ?? ''}
			title='Iframe'
			style={{
				width: '100%',
				height: '100vh',
			}}
		/>
	);
};

export default Iframe;
